<template>
  <div class="binyi-toolbar">
    <span class="binyi-toolbar-icon">
      <img v-if="environment()" src="@/assets/images/components/logo.png" />
      <img v-if="!environment()" src="@/assets/images/components/logo_.png" />
    </span>
    <span class="binyi-toolbar-name">中广{{environment() ? '家书':'训练'}}管理系统</span>

    <el-dropdown
      v-show="showUserName"
      trigger="click"
      class="binyi-username"
      @visible-change="visibleChange"
      @command="handleCommand"
    >
      <span class="el-dropdown-link">
        <img v-if="environment()" src="@/assets/images/components/logo.png" />
        <img v-if="!environment()" src="@/assets/images/components/logo_.png" />
        管理员：{{ (loginInfo.unitShortName != undefined ? loginInfo.unitShortName + '+' : '') + (loginInfo.name != undefined ? loginInfo.name : '')}}
        <span :class="{ 'upsideDown' : dropdownMenuShow }" class="el-icon-arrow-down"></span>
      </span>
      <el-dropdown-menu slot="dropdown" class="binyi-username-dropdown">
        <el-dropdown-item
          command="editPwd"
          v-if="showChangePwd"
          style="border-bottom: #eaeaea 1px solid"
        >
          <div class="cell">
            <img
              class="icon"
              src="@/assets/images/components/menu_change.png"
            />
            修改密码
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="unlogin">
          <div class="cell">
            <img class="icon" src="@/assets/images/components/menu_quit.png" />
            退出登录
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import mixin from "./Mixins";
import { environment } from "@/utils/utils";

export default {
  mixins: [mixin],
  data(){
    return {
      dropdownMenuShow:false
    }
    
  },
  computed: {
    showUserName() {
      let path = this.$route.path.toLowerCase();
      return !path.startsWith("/userlogin");
    },
    loginInfo() {
      return this.UserLogin.binyi_cms_loginInfo;
    },
    showChangePwd() {
      return this.$route.path != "/frompasres"
    }
  },

  methods: {
    environment(){
      return environment()
    },
    async handleCommand(command) {
      if (command == "unlogin") {
        this.sendLoginOut();
        this.SETOPTIONS({
          binyi_cms_loginInfo: { role: {} },
          ruleForm: {
            unit: "",
            account: "",
            pwd: "",
            baseReqDto: "",
          },
        });
      } else if (command == "editPwd") {
        this.$router.push({
          path: "/frompasres",
        });
      }
    },
    visibleChange(v) {
      this.dropdownMenuShow = v;
    }
  },
};
</script>

<style lang="stylus">
.binyi-username {
  margin-left: auto;
  margin-right: 100px;

  .el-dropdown-link {
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    color: #333333;

    img {
      width: 34px;
      height: 34px;
      margin-right: 11px;
    }
    .upsideDown {
      transform :rotate(180deg)  
    }
  }

  .el-icon-arrow-down {
    margin-left: 10px;
  }
  
}


.el-dropdown-menu__item {
    .cell {
      height: 60px;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 12px;

      .icon {
        margin-right: 10px;
        width: 18px;
        height: 18px;
      }
    }
  }
</style>
<style lang="stylus" scoped>
.binyi-toolbar {
  width: 100%;
  height: 80px;
  background: #ffffff;
  line-height: 80px;
  display: flex;
  align-items: center;
  border-bottom: #D8D8D8 solid 1px;
  box-sizing: border-box;

  .binyi-toolbar-icon {
    margin: 0 10px 0 58px;
    width: 50px;

    img {
      width: 100%;
      vertical-align: middle;
    }
  }

  .binyi-toolbar-name {
    font-size: 22px;
    font-weight: 500;
    color: #333333;
  }

  
}
.el-dropdown-menu {
  padding :0 !important;
  min-width :130px;
  border-radius :10px;
}
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue